import { useEffect, useState } from "react";
import FilteringSidePanel from "../../../../shared/oversight-core/shared-components/filtering-side-panel/filtering-side-panel";
import AppSelect, {
  Option,
} from "../../../../shared/oversight-core/ui-elements/app-select/app-select";

interface IProps {
  show: boolean;
  onClose: () => void;
  updateFilters: (generationServiceProviderId?: string) => void;
  setFilterBadgeValue: React.Dispatch<React.SetStateAction<number>>;
  filters: { generationServiceProviderId?: string };
  solarBrandList: Option[];
}

const solarBrandDefaultOption: Option = {
  value: "",
  label: "Select a solar brand",
};

const SitesErrorLogFilterPanel = (props: IProps) => {
  const {
    show,
    filters,
    onClose,
    updateFilters,
    setFilterBadgeValue,
    solarBrandList,
  } = props;

  const [selectedSolarBrand, setSelectedSolarBrand] = useState<Option>({
    ...solarBrandDefaultOption,
  });

  useEffect(() => {
    if (!filters.generationServiceProviderId) {
      setSelectedSolarBrand({ ...solarBrandDefaultOption });
    }
  }, [filters]);

  useEffect(() => {
    if (selectedSolarBrand?.value) {
      setFilterBadgeValue(1);
    } else {
      setFilterBadgeValue(0);
    }
  }, [selectedSolarBrand?.value, setFilterBadgeValue]);

  return (
    <FilteringSidePanel
      isOpen={show}
      onClose={onClose}
      onFilter={() => {
        updateFilters(selectedSolarBrand.value);
        onClose();
      }}
      onClearAll={() => {
        onClose();
        setSelectedSolarBrand({
          ...solarBrandDefaultOption,
        });

        updateFilters("");
      }}
    >
      <>
        <AppSelect
          className="text-light font-size-14"
          selectedValue={selectedSolarBrand}
          label="Solar Brand"
          options={solarBrandList}
          onChangeOption={(selectedOption) => {
            setSelectedSolarBrand(selectedOption);
          }}
          isRequired={false}
          labelFontSize="font-size-14"
        />
      </>
    </FilteringSidePanel>
  );
};

export default SitesErrorLogFilterPanel;
